import React, { useEffect }  from "react"
import { useStaticQuery, graphql, Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import styled from 'styled-components'

import SmallArrow from '../../svgs/small-arrow.svg'
import CrystalDataBall from '../../svgs/crystal-data-ball.svg'

import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"

const HeroSection = () => {

    // Randomize Banner Image
    const max = 5;
    const rand = Math.floor(Math.random() * max);

    const data = useStaticQuery(graphql`
        query {
            bannerOne: file(relativePath: { eq: "data-dinner.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerTwo: file(relativePath: { eq: "data-flames.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerThree: file(relativePath: { eq: "data-limes.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerFour: file(relativePath: { eq: "data-pipes.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerFive: file(relativePath: { eq: "data-shower.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
        }
    `)

    return(
        <HeroMain>
            <div class={rand === 0 ? "hero-banner banner-1" : rand === 1 ? "hero-banner banner-2" : rand === 2 ? "hero-banner banner-3" : rand === 3 ? "hero-banner banner-4" : "hero-banner banner-5"}>
                <div
                data-sal="fade"
                data-sal-duration="1000"
                data-sal-easing="ease">
                <GatsbyImage className={"hero-bg hero-bg-1"} image={data.bannerOne.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Dinner Data"}/>
                <GatsbyImage className={"hero-bg hero-bg-2"} image={data.bannerTwo.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Flames Data"}/>
                <GatsbyImage className={"hero-bg hero-bg-3"} image={data.bannerThree.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Limes Data"}/>
                <GatsbyImage className={"hero-bg hero-bg-4"} image={data.bannerFour.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Pipes Data"}/>
                <GatsbyImage className={"hero-bg hero-bg-5"} image={data.bannerFive.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Shower Data"}/>
                </div>
            </div>
            <div 
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-easing="ease"
            class="hero-content">
                <div>
                    <h1>Predictive Marketing + Communications</h1>
                    <h2>Specializing in Food & Energy Brands</h2>
                </div>
            </div>
        </HeroMain>
    );

}

const HeroMain = styled.section`
    background-color: #000;
    .hero-banner {
        height: 85vh;
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        > div {
            transition-delay: 1s;
        }
        .hero-bg {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
        }
        &.banner-1 {
            .hero-bg-1 {
                opacity: 1;
                visibility: visible;
            }
        }
        &.banner-2 {
            .hero-bg-2 {
                opacity: 1;
                visibility: visible;
            }
        }
        &.banner-3 {
            .hero-bg-3 {
                opacity: 1;
                visibility: visible;
            }
        }
        &.banner-4 {
            .hero-bg-4 {
                opacity: 1;
                visibility: visible;
            }
        }
        &.banner-5 {
            .hero-bg-5 {
                opacity: 1;
                visibility: visible;
            }
        }
    }
    .hero-content {
        position: absolute;
        transition-delay: 1.5s;
        height: 100vh;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        h1 {
            font-family: "Nobel",sans-serif;
            font-size: 130px;
            line-height: 1.1;
            color: #fff;
            text-align: center;
            transition-duration: .3s;
        }
        h2 {
            font-family: "Work Sans";
            font-size: 40px;
            font-weight: 400;
            line-height: 1.2;
            color: #fff;
            text-align: center;
            transition-duration: .3s;
        }
    }
    @media(max-width: 1420px) {
        .hero-content {
            h1 {
                font-size: 100px;
            }
        }
    }
    @media(max-width: 1080px) {
        .hero-content {
            h1 {
                font-size: 72px;
            }
            h2 {
                font-size: 32px;
            }
        }
    }
    @media(max-width: 767px) {
        .hero-content {
            h1 {
                font-size: 48px;
            }
            h2 {
                font-size: 24px;
            }
        }
    }
    @media(max-width: 359px) {
        .hero-content {
            h1 {
                font-size: 36px;
            }
        }
    }
`

export default HeroSection